module.exports = __webpack_public_path__ + "static/Semi-dried-tomatoes-47b6a94abfdef7d4dd8b8711e52b23d4.png";